<script setup lang="ts">
import type { TBannerCatalogGridItem } from '~/layers/marketing/types'
defineProps({
  banner: {
    type: Object as PropType<TBannerCatalogGridItem>,
    required: true,
  },
})
</script>

<template>
  <div v-if="banner.video && banner.video.desktop.link && banner.video.mobile.link" class="catalog__banner_vertical-video catalog__banner">
    <UVideo
        autoplay
        isPlay
        class="custom-slider-video"
        loop
        muted
        playsinline
        disableControls
      >
      <source :src="banner.video.desktop.link" media="(min-width:760px)" type="video/mp4" />
      <source :src="banner.video.mobile.link" media="(max-width:759px)" type="video/mp4" />
    </UVideo>
  </div>
  <div v-else class="catalog__banner_vertical catalog__banner">
    <URemotePicture :picture="banner.picture" />
  </div>
</template>

<style lang="scss">
.catalog__banner_vertical-video {
  transform: translateY(1px);
  overflow: hidden;
  .custom-slider-video {
    width: calc(100% + 4px);
  }
}

.catalog__banner_vertical .custom-slider-video{
  width: 100%;
}
</style>
